import { render, staticRenderFns } from "./CustomerMotorFinalization.vue?vue&type=template&id=2aa4bbed"
import script from "./CustomerMotorFinalization.vue?vue&type=script&lang=js"
export * from "./CustomerMotorFinalization.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/customer-motor.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports